'use strict';

/* Components */
import dropdownToggleDirective from './dropdown-toggle/dropdown-toggle.directive';
import footer from './footer/footer.component';
import inplaceEditHover from './inplace-edit-hover/inplace-edit-hover.directive';
import jsonViewComponent from './json-view/json-view.component';
import jsonViewDirective from './json-view/json-view.directive';
import modal from './modal/modal.service';
import mongooseError from './mongoose-error/mongoose-error.directive';
import newlineToHtml from './newline-to-html/newlineToHtml.filter';
import socket from './socket/socket.service';
import startFrom from './start-from/startFrom.filter';
import util from './util/util.module';
import datatableViewer from './datatable-view/datatable-view.component';
import eFormLink from './eform-link/eform-link.component';
import eFormModal from './eform-modal/eform-modal.component';
import eFormResultTableLink from './eform-result-table-link/eform-result-table-link.component';
import detailListModal from './detail-list-modal/detail-list-modal.component';
import extendedDataTable from './extended-datatable/extended-datatable.component';
import suiteEntityDatatable from './suite-entity-datatable/suite-entity-datatable.component';
import suiteEntityTemplateIter from './suite-entity-template-iter/suite-entity-template-iter.component';

/* Module */
export default angular.module('conduu.ap.components', [
  dropdownToggleDirective, footer, inplaceEditHover, jsonViewComponent, jsonViewDirective, modal, mongooseError,
  newlineToHtml, socket, startFrom, util, datatableViewer, eFormLink, eFormModal, eFormResultTableLink,
  detailListModal, extendedDataTable, suiteEntityDatatable, suiteEntityTemplateIter])
.name;



// WEBPACK FOOTER //
// ./client/~ap/components/index.js